import { cx } from "cva";
import { BuildHTML } from "~/components/BuildHtml/BuildHtml";
import { FeatureWithDemo } from "~/components/LandingPage/schemas";
import { DemoForm } from "~/landing-pages/components/Demo/DemoForm";
import {
  backgroundColorStyle,
  primaryTextColorStyle,
  secondaryTextColorStyle,
} from "~/landing-pages/shared-landing-page-styles";
import { tagToClassNameMap } from "~/landing-pages/utils/tagToClassNameMap";
import { RequestDemoFormSchema } from "~/lib/shared/schemas/requestDemoSchema";
import { Body, Headline } from "~/ui-library";

export type FeatureWithDemoCenteredProps = Omit<
  FeatureWithDemo,
  "layout" | "successMessage" | "successRedirectUrl"
> & {
  appearance: "brand" | "dark" | "light";
  onFormSubmit: (values: RequestDemoFormSchema) => void;
};

const appearance = "light";

export const FeatureWithDemoCentered: React.FC<
  FeatureWithDemoCenteredProps
> = ({ title, description, onFormSubmit, ...formProps }) => (
  <div className={cx("isolate", backgroundColorStyle({ appearance }))}>
    <div className="w-full">
      <div
        className="relative inset-x-0 top-[-10rem] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[-20rem]"
        aria-hidden="true"
      >
        <div
          className="absolute left-1/2 -z-10 aspect-[1155/678] w-[36.125rem] max-w-none -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-40rem)] sm:w-[72.1875rem]"
          style={{
            clipPath:
              "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
          }}
        />
      </div>
      <div className="mx-auto max-w-2xl md:text-center">
        <Headline
          as="h2"
          level={1}
          className={cx(primaryTextColorStyle({ appearance }), "font-bold")}
        >
          {title}
        </Headline>
        <Body
          className={cx(secondaryTextColorStyle({ appearance }), "mt-2")}
          size="large"
        >
          <BuildHTML html={description} tagToClassNameMap={tagToClassNameMap} />
        </Body>
      </div>
      <DemoForm
        {...formProps}
        appearance={appearance}
        className="mt-10"
        onFormSubmit={onFormSubmit}
      />
    </div>
  </div>
);
